import React, { useEffect, useState, useMemo } from 'react';
import TabbedNavigation from "@/components/TabbedNavigation.jsx";
import TaxRulesTable from "./TaxRulesTable.jsx";
import { getTaxRules } from "../../api/taxRules.js";

const TaxRulesTab = () => {
  const [selectedTab, setSelectedTab] = useState('all');
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await getTaxRules();
      setRules(data);
    } catch (error) {
      console.error("Error loading tax rules:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      await loadData();
      if (cancelled) return;
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const filteredRules = useMemo(() => {
    let filtered = rules;

    // Filter by tab
    if (selectedTab === 'statewide') {
      filtered = filtered.filter(r => r.statewide);
    } else if (selectedTab === 'zip-codes') {
      filtered = filtered.filter(r => r.zip_codes?.length > 0);
    } else if (selectedTab === 'cities') {
      filtered = filtered.filter(r => r.cities?.length > 0);
    }

    // Filter by search
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter(r => {
        return (
          r.name?.toLowerCase().includes(q) ||
          r.state_codes?.some(sc => sc.toLowerCase().includes(q)) ||
          r.zip_codes?.some(zc => zc.toLowerCase().includes(q)) ||
          r.cities?.some(c => c.toLowerCase().includes(q))
        );
      });
    }

    return filtered;
  }, [rules, selectedTab, searchQuery]);

  return (
    <>
      {/* Search bar */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by name, state, zip code, or city..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="form-input w-full md:w-96"
        />
      </div>

      {/* Sub-tabs */}
      <div className="sm:flex sm:justify-between sm:items-center mb-8">
        <div className="flex items-center">
          <TabbedNavigation
            tabs={[
              { id: 'all', label: 'All Rules' },
              { id: 'statewide', label: 'Statewide' },
              { id: 'zip-codes', label: 'Zip Codes' },
              { id: 'cities', label: 'Cities' }
            ]}
            activeTab={selectedTab}
            onTabChange={(newTab) => setSelectedTab(newTab)}
            variant="default"
            size="md"
          />
        </div>
      </div>

      {/* Table */}
      <TaxRulesTable
        rules={filteredRules}
        loading={loading}
        onRuleChange={loadData}
      />
    </>
  );
};

export default TaxRulesTab;
